import { create } from "zustand";
import { ROLE } from "../Utils/constant";
import { find } from "../services/service";
export const useRoleStore = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  getData: async () => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const getItems = await find(`${ROLE}`);
      setTimeout(() => {
        set({
          loading: false,
          data: getItems?.data?.donnee,
          count: getItems.data.totalPages,
        });
      }, 1000);
    } catch (error) {
      set({
        loading: true,
        data: [],
      });
    }
  },
}));
